import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Facebook from 'react-facebook-login';
import { Button } from '../../UI';
import facebookIcon from '../../../assets/icons/facebook.svg';
/**
 * Renders the facebook login button
 *
 * @param  {string} [appId] - {string} [apiId] - the app id or client id required by provider
 * @param  {(response: any) => void} [callback] - callback with response from social provider
 *
 * @example
 * <FacebookLogin
 *  callback={response => console.log(response)}
 *  appId='000000000'
 * />
 */
var FacebookLogin = function (_a) {
    var callback = _a.callback, appId = _a.appId;
    var responseFacebook = function (response) {
        var expiresAt = response.expiresIn * 1000 + new Date().getTime();
        var token = response.accessToken;
        callback(__assign(__assign({}, response), { user: {
                email: response.email,
                providerId: response.id,
                provider: 'facebook',
            }, token: token,
            expiresAt: expiresAt }));
    };
    return (React.createElement("div", { className: 'a6y-react-auth__facebook-login' },
        React.createElement(Facebook, { appId: appId, callback: responseFacebook, fields: 'name,email', render: function (renderProps) { return (React.createElement(Button, { role: 'button', className: 'a6y-react-auth__facebook-btn', onClick: renderProps.onClick },
                React.createElement("img", { src: facebookIcon, alt: 'facebook-icon' }),
                " Login with Facebook")); } })));
};
export default FacebookLogin;
//# sourceMappingURL=FacebookLogin.js.map